import TextEditor from 'globalComponents/TextEditor';
import React from 'react';

const App = () => (
  <div className="bg-light-gray p-24">
    <TextEditor value="test" onChange={() => {}} />
  </div>
);

export default App;
